<template>
  <el-aside class="menu" height="100%" width="200px">
    <el-menu
      @open="handleOpen"
      @close="handleClose"
      background-color="#fff"
      text-color="#666"
      active-text-color="#0B7CC4"
      :default-active="$route.path"
      router="router"
      class="admin_menu"
    >
      <el-menu-item :index="ROUTER_PATH.PROCESS_LIST" >
        <i class="el-icon-magic-stick"></i>
        <span slot="title">{{this.$t('menu.process')}}</span>
      </el-menu-item>
      <el-menu-item :index="ROUTER_PATH.ROBOT_MY_ROBOT" >
        <i class="el-icon-monitor"></i>
        <span slot="title">{{this.$t('menu.robot')}}</span>
      </el-menu-item>
      <el-menu-item :index="ROUTER_PATH.ROBOT_MONITOR" >
        <i class="el-icon-cloudy"></i>
        <span slot="title">{{this.$t('menu.cloud')}}</span>
      </el-menu-item>
      <el-menu-item :index="ROUTER_PATH.ROBOT_RUNNING_REPORT" >
        <i class="el-icon-pie-chart"></i>
        <span slot="title">{{this.$t('menu.report')}}</span>
      </el-menu-item>
      <el-menu-item :index="ROUTER_PATH.PAY_REPORT" >
        <i class="el-icon-coin"></i>
        <span slot="title">{{this.$t('menu.bill')}}</span>
      </el-menu-item>
      <el-submenu v-if="accountInfo.role === 'A'">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>{{this.$t('menu.admin')}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="ROUTER_PATH.ADMIN_USER" >{{this.$t('menu.user')}}</el-menu-item>
          <el-menu-item :index="ROUTER_PATH.ADMIN_ROLE" >{{this.$t('menu.group')}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
import { mapState } from "vuex";
import { ROUTER_PATH } from "@/constants/common.js";
export default {
  name: "CommonLeftMenu",
  data: () => {
    return {
      ROUTER_PATH: ROUTER_PATH,
    };
  },
  computed: {
    ...mapState(["accountInfo"]),
  },
   methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
   }
};
</script>

<style>
.el-menu{border:none;}
.admin_menu{min-height: 500px;}
</style>
